module.exports = __webpack_public_path__ + "static/media/perf.3094c3fa.png";